<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>
      როგორ იმოგზაურა ეკამ 30-ზე მეტ ქვეყანაში ბიუჯეტურად?
    </h1>
    <h6>აპრილი 2023</h6>
    <br />

    <p>
      ყველა ვთანხმდებით, რომ მოგზაურობა ის ინტერესია, რომელიც თითოეულ ჩვენგანს აერთიანებს. განსაკუთრებით მიმზიდველია,
      როდესაც შესაძლებლობა გაქვს ახალი ქვეყნები, თუ ქალაქები ბიუჯეტურად დაათვალიერო. ჩვენს გუნდშიც ბევრი ისეთი
      ადამიანია, ვისთვისაც მუდმივი სიახლეების ძიება მთავარი ინტერესია. გვინდა გამოვარჩიოთ ერთ-ერთი მათგანი, რომლისთვისაც
      მოგზაურობის დაგეგმვის პროცესი დროდადრო უფრო მარტივდება. ამ ბლოგში ჩვენი ბუღალტერიის გუნდის წევრი - ეკა ვეშაგური
      გიზიარებთ რჩევებს, თუ როგორ შეგიძლიათ მინიმალური რესურსებით დაათვალიეროთ რამდენიმე ქვეყანა.
    </p>

    <img src="../../../../assets/blog/travel-tips/img1.jpg" alt="" />

    <p><b class="blue">პირველ რიგში, რა ასაკში დაიწყე მოგზაურობა და რომელ ქვეყანაზე შეაჩერე არჩევანი? </b></p>

    <p>
      პირველი ქვეყანა, რომელიც ხელმისაწვდომობის გამო 22 ან 23 წლის ასაკში დამოუკიდებლად მოვინახულე - თურქეთი იყო.
    </p>

    <p><b class="blue">ამ ეტაპზე რამდენ ქვეყანაში ხარ ნამყოფი და რომელს გამოარჩევდი?</b></p>

    <p>
      დღესდღეობით 30-ზე მეტი ქვეყანა მაქვს ნანახი. გამოვარჩევდი ჰოლანდიას, ფინეთსა და ნორვეგიას.
    </p>

    <p><b class="blue">რა კრიტერიუმების მიხედვით არჩევ ქვეყანას?</b></p>

    <p>
      როდესაც მოგზაურობა დავიწყე მივდიოდი იქ, რა მიმართულებითაც ბილეთები ყველაზე იაფი იყო. ახლა ვცდილობ ისეთი ქვეყნები
      ავარჩიო, სადაც არ ვარ ნამყოფი, ან ნამყოფი ვარ და სხვა ქალაქები თუ სოფლები მაინტერესებს.
    </p>

    <p><b class="blue">გაგვიზიარე რჩევები, როგორ ვიმოგზაუროთ ეკონომიურად.</b></p>

    <p>
      ჩემთვის პრიორიტეტული ევროპის ნებისმიერ ქვეყანაში ბიუჯეტურად მოხვედრაა. სწორედ ამიტომ, არჩევანს ბილეთის ფასის გამო
      Wizzair-ზე ვაჩერებ, მართალია, ამიტომ ყოველი ფრენის წინ ქუთაისში მიწევს ჩასვლა, თუმცა უკვე შევეჩვიე. ევროპაში შიდა
      ფრენები იაფია. იქიდან გამომდინარე რომ, ბილეთის ფასები ყოველდღიურად იცვლება, მას მუდმივად ვათვალიერებ.
    </p>

    <p>
      საძიებო სისტემის გამოყენების ჩემი ხრიკებიც მაქვს, რომელსაც სიამოვნებით გაგიზიარებთ. მოგზაურობის დაგეგმვის პირველ
      ეტაპზე, ბილეთების მაქსიმალურად მისაღები ფასის სანახავად, საძიებო სისტემას თვეებად ან ქვეყნებად ვახარისხებ,
      შესაბამისად, იმ ქვეყნის ბილეთებს ვყიდულობ, რომელიც ჩემთვის იმ მომენტში ყველაზე ხელმისაწვდომია. ასევე, რადგან
      ხშირად ვმოგზაურობ, მაქვს კლუბის წევრობა და წლის განმავლობაში ყველა ფრენაზე, თუ ბარგის შეძენაზე დამატებითი
      ფასდაკლებით ვსარგებლობ.
    </p>

    <p><b class="blue">უახლოეს მომავალში რომელ ქვეყანაში გეგმავ მოგზაურობას?</b></p>

    <p>
      წელს ჯერ რაც ზუსტად ვიცი და ნაყიდი მაქვს არის მალდივები, ემირატები, ლუქსემბურგი, საფრანგეთი, შვედეთი, პოლონეთი,
      თურქეთი, უზბეკეთი. ზუსტად არ ვიცი კიდევ რა შემომეყიდება.
    </p>
  </div>

  <div class="carousel">
    <app-custom-carousel [images]="images" [customOptions]="customOptions"></app-custom-carousel>
  </div>

  <div class="container blog-item custom">
    <p><b class="blue">ქვეყანა საუკეთესო კულტურით</b> - იტალია</p>
    <p><b class="blue">საუკეთესო სამზარეულოთი</b> - ჩემთვის იტალია</p>
    <p><b class="blue">ხალხი, რომელიც გამორჩეულად დამამახსოვრდა</b> - ხორვატიელები, ნორვეგიელები</p>
    <p><b class="blue">მეტს ველოდი</b> - კატანია (სიცილია)</p>
    <p><b class="blue">გადააჭარბა მოლოდინს</b> - პორტუგალია</p>
    <p><b class="blue">კიდევ ვეწვეოდი</b> - ნებისმიერ ქვეყანას, ესე არ მაქვს რომ რომელიმეში აღარ წავალ</p>
    <p><b class="blue">ყველაზე არაბიუჯეტური</b> - ემირატები</p>
    <p><b class="blue">ვიცხოვრებდი</b> - ჰოლანდია, ასევე სიცივის მიუხედავად სკანდინავიაში</p>
    <p><b class="blue">საუკეთესო გართობა</b> - მიკონოსი, ამსტერდამი</p>
    <p><b class="blue">კულტურული დასვენებისთვის</b> - იტალია</p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      How Eka Traveled to Over 30 Countries on a Budget
    </h1>
    <h6>April 2023</h6>
    <br />

    <p>
      We all agree that travel is an interest that unites each of us. It is especially appealing when you have the
      opportunity to explore new countries or cities on a budget. In our team, there are many people for whom the search
      for new experiences is a main interest. We would like to highlight one of them, whose travel planning process
      becomes easier over time. In this blog, Eka Veshaguri, a member of our accounting team, shares tips on how you can
      explore several countries with minimal resources.
    </p>

    <img src="../../../../assets/blog/travel-tips/img1.jpg" alt="" />

    <p><b class="blue">At what age did you start traveling, and which country did you choose?</b></p>

    <p>The first country I visited independently at around 22 or 23 years old due to accessibility was Turkey.</p>

    <p><b class="blue">How many countries have you visited so far, and which one would you highlight?</b></p>

    <p>I have visited over 30 countries so far. I would highlight the Netherlands, Finland, and Norway.</p>

    <p><b class="blue">What criteria do you use to choose a country?</b></p>

    <p>
      When I started traveling, I went to places where tickets were the cheapest. Now, I try to choose countries where I
      haven’t been yet, or if I have been, I’m interested in exploring other cities or villages.
    </p>

    <p><b class="blue">Share some tips on how to travel economically.</b></p>

    <p>
      For me, my priority is to travel on a budget to any country in Europe. That’s why I usually choose Wizzair for
      tickets, even though it means I have to go to Kutaisi before every flight, but I’ve gotten used to it. Domestic
      flights within Europe are inexpensive. Since ticket prices change daily, I constantly check them.
    </p>

    <p>
      I also have a few tricks when using search engines, which I’m happy to share. In the initial stage of planning a
      trip, to find the most affordable tickets, I sort the search engine by months or countries, and I buy tickets to
      the country that’s most accessible at the moment. Also, since I travel often, I have a membership in a club, which
      gives me additional discounts on every flight or when purchasing luggage throughout the year.
    </p>

    <p><b class="blue">Which country are you planning to travel to in the near future?</b></p>

    <p>
      This year, I already know and have tickets for the Maldives, the Emirates, Luxembourg, France, Sweden, Poland,
      Turkey, and Uzbekistan. I’m not sure what else I’ll end up buying.
    </p>
  </div>

  <div class="carousel">
    <app-custom-carousel [images]="images" [customOptions]="customOptions"></app-custom-carousel>
  </div>

  <div class="container blog-item custom">
    <p><b class="blue">Country with the best culture </b> - Italy</p>
    <p><b class="blue">Best cuisine </b> - For me, Italy</p>
    <p><b class="blue">People who left a lasting impression </b> - Croatians, Norwegians</p>
    <p><b class="blue">Expected more </b> - Catania (Sicily)</p>
    <p><b class="blue">Exceeded expectations</b> - Portugal</p>
    <p><b class="blue">Would visit again </b> - Any country, I don’t have a specific place I wouldn’t go to again</p>
    <p><b class="blue">Most expensive</b> - Emirates</p>
    <p><b class="blue">I would live in</b> - Netherlands, also Scandinavia despite the cold</p>
    <p><b class="blue">Best entertainment</b> - Mykonos, Amsterdam</p>
    <p><b class="blue">For cultural relaxation</b> - Italy</p>
  </div>
</ng-container>
